module.exports = __webpack_public_path__ + "VIPG4.png?565b8e9cd3a361d895797ee9640a4870";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/greyhounds/VIPG4.png
// module id = 76
// module chunks = 0